import { atom } from 'jotai';

export const isPersonalOptionOpenAtom = atom<boolean>(false);
